export const isEmpty = (item: object) =>
  !item || Object.keys(item).length === 0;
